/**
 * Menu component (used with Blurb Menu)
 */

import * as React from "react";
import { Link } from "gatsby";
import "../styles/blurb-menu.css";

const Menu = ({ data, location }) => {
  const menuItems = data?.allMenuItems?.nodes;
  return (
    <nav>
      {menuItems?.length ? (
        <>
          {menuItems.map((c1, index) => {
            return (
              <>
                {c1.childrenMenuItems?.length ? (
                  <div key={"blurb-menu-" + index} class="menu">
                    {c1.url ? (
                      <Link
                        to={c1.url}
                        className={`blurb-menu-link ${
                          location?.pathname === c1.url
                            ? "blurb-menu-link-active"
                            : ""
                        }`}
                      >
                        {c1.title ? c1.title : null}
                      </Link>
                    ) : (
                      <div
                        className={`blurb-menu-link ${
                          location?.pathname === c1.url
                            ? "blurb-menu-link-active"
                            : ""
                        }`}
                      >
                        {c1.title ? c1.title : null}
                      </div>
                    )}
                    <ul className="ml-2 submenu">
                      {c1.childrenMenuItems.map((c2, index2) => {
                        return (
                          <li
                            key={"blurb-menu-" + index + "-" + index2}
                            className="my-2"
                          >
                            <Link
                              className={`blurb-menu-link block ${
                                location?.pathname === c2.url
                                  ? "blurb-menu-link-active"
                                  : ""
                              }`}
                              key={c2.url}
                              to={c2.url}
                            >
                              {c2.title}
                            </Link>
                            {c2.childrenMenuItems?.length ? (
                              <ul className="ml-2 submenu">
                                {c2.childrenMenuItems.map((c3, index3) => (
                                  <li
                                    key={
                                      "blurb-menu-" +
                                      index +
                                      "-" +
                                      index2 +
                                      "-" +
                                      index3
                                    }
                                    className={``}
                                  >
                                    <Link
                                      className={`blurb-menu-link text-gray ${
                                        location?.pathname === c3.url
                                          ? "blurb-menu-link-active"
                                          : ""
                                      }`}
                                      to={c3.url}
                                      target={c3.target}
                                    >
                                      {c3.title}
                                    </Link>
                                  </li>
                                ))}
                              </ul>
                            ) : null}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                ) : (
                  <div key={"blurb-menu-" + index}>
                    <Link
                      to={c1.url}
                      className={`blurb-menu-link ${
                        location?.pathname === c1.url
                          ? "blurb-menu-link-active"
                          : ""
                      }`}
                    >
                      {c1.title ? c1.title : null}
                    </Link>
                  </div>
                )}
              </>
            );
          })}
        </>
      ) : null}
    </nav>
  );
};

export default Menu;
